import { render } from "./tabs-swift.vue?vue&type=template&id=8a354444&scoped=true"
import script from "./tabs-swift.vue?vue&type=script&lang=js"
export * from "./tabs-swift.vue?vue&type=script&lang=js"

import "@/assets/scss/common/tab/tab-swift.scss?vue&type=style&index=0&id=8a354444&scoped=true&lang=scss"

import exportComponent from "/Users/thanhnguyen/Desktop/ThanhNguyen/projects/public_html/numbers-betting-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8a354444"]])

export default __exports__